import { window } from "@swa-ui/browser";

export const getLowerEnvironmentId = () =>
  Array.from(window.location?.hostname?.match(/.*?[.](.*?\d)[.].*/) ?? ["", ""])[1];
